import { useState } from 'react';
import { useRef } from 'react';
//import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
    Button,
    ButtonGroup,
    ClickAwayListener,
    Grow,
    MenuItem,
    MenuList,
    Paper,
    Popper
} from '@material-ui/core'
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { PARAMETROS_ARCHIVOS_EMPADRONAMIENTO } from '../../../utils/constants';
import { DescargarPlantillaEmpadronamientoHCE } from '../../../actions/hce/hceActions';

export const PlantillaEmpadronamiento = ({ descarga }) => {
    const dispatch = useDispatch();

    const fileInputRef = useRef();
    const anchorRef = useRef(null);

    const [open, setOpen] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);

    const handleMenuItemClick = (event, index) => {
        setSelectedIndex(index);
        setOpen(false);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };
    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    const handleFileUpload = () => {
        fileInputRef.current.click();
    }

    const handleChangeFile = (e) => {
        //dispatch(subirArchivoContrataciones(e.target.files[0], parametrosContrataciones[selectedIndex]?.id));
        e.target.value = null
    }
    const downloadFile = () => {
        dispatch(DescargarPlantillaEmpadronamientoHCE(PARAMETROS_ARCHIVOS_EMPADRONAMIENTO[selectedIndex]?.id));
    };



    return (
        <>
            <ButtonGroup
                variant="contained"
                color="inherit"
                ref={anchorRef}
                aria-label="split button"
                style={{ float: "right" }}
            >
                {descarga ?
                    null
                    :
                    <input
                        type='file'
                        name='archivos'
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                        onChange={descarga ? downloadFile : handleChangeFile}
                    />
                }
                <Button
                    color="inherit"
                    onClick={descarga ? downloadFile : handleFileUpload}
                    startIcon={descarga ? <CloudDownloadIcon /> : <CloudUploadIcon />}
                    style={{ borderRadius: "3px 0px 0px 3px" }}
                >
                    {descarga
                        ? `Plantilla - ${PARAMETROS_ARCHIVOS_EMPADRONAMIENTO[selectedIndex]?.descripcion}`
                        : PARAMETROS_ARCHIVOS_EMPADRONAMIENTO[selectedIndex]?.descripcion
                    }
                </Button>
                <Button
                    color="inherit"
                    size="small"
                    aria-controls={open ? 'split-button-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-label="select merge strategy"
                    aria-haspopup="menu"
                    onClick={handleToggle}
                >
                    <ArrowDropDownIcon />
                </Button>
            </ButtonGroup>
            <Popper 
                open={open} 
                anchorEl={anchorRef.current} 
                role={undefined} 
                transition 
                disablePortal
                style={{zIndex:1}}
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                        }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                            <MenuList id="split-button-menu">
                                {PARAMETROS_ARCHIVOS_EMPADRONAMIENTO.map((option, index) => (
                                    <MenuItem
                                        key={option.id}
                                        selected={index === selectedIndex}
                                        onClick={(event) => handleMenuItemClick(event, index)}
                                    >
                                        {descarga  
                                            ? `Descargar plantilla - ${option.descripcion}`
                                            : option.descripcion
                                        }
                                    </MenuItem>
                                ))}
                            </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </>
    )
}
